import React, { useRef } from 'react'
import { useIsVisible } from 'react-is-visible'

function LazyWidget({ children, minHeight = 350 }) {
    const nodeRef = useRef()
    const isVisible = useIsVisible(nodeRef, { once: true })

    return (
        <div ref={nodeRef} style={{ minHeight: isVisible ? 'auto' : minHeight }}>
            {children(isVisible)}
        </div>
    )
}

export default LazyWidget
